// api
import PresentationApi from '@/api/presentation'
import router from '@/router'
// 3rd parties
import hotjar from '@/services/hotjar'

const identifyUserToHotjarAction = (state, numberOfPresentations) => {
  const { currentUser, folders, selections: { selectedFolderId } } = state
  if (!selectedFolderId) {
    const numberOfPresentationsInsideFolder = folders.reduce((accummulator, folder) => {
      return accummulator + folder.countPresentationRecursive
    }, 0)

    // Once sent to Hotjar, these attributes and the values for each user
    // are stored on Hotjar’s servers.
    // Each time a call to Identify is made,
    // the values stored on Hotjar’s servers will be
    // replaced with the most recent values for these attributes.
    hotjar.identifyUser({
      email: currentUser.email,
      plan: currentUser.plan,
      abTestGroup: currentUser.id % 4,
      signedUpAt: currentUser.createdAt,
      userId: currentUser.id,
      country: currentUser.country,
      numberOfPresentations: numberOfPresentations + numberOfPresentationsInsideFolder,
      lastEventStartedAt: currentUser.lastEventStartedAt,
      accountRole: currentUser.accountRole,
      accountId: currentUser.accountId,
    })
  }
}

const setPresentationsAction = ({ commit }, payload) => {
  commit('setPresentations', payload)
}

const getPresentationsAction = async ({ commit, state }, payload = {}) => {
  const res = await PresentationApi.getPresentations(payload)
  // Fix AHA-5419
  if (router.currentRoute.name === 'SharedWithMe') return
  const { presentations, numberOfPresentations, numberOfPresentationPages } = res
  if (payload.page === 1) {
    commit('setPresentations', presentations)
  } else {
    commit('setPresentations', [...state.presentations, ...presentations])
  }

  commit('setNumberOfPresentationPages', numberOfPresentationPages)
  identifyUserToHotjarAction(state, numberOfPresentations)
}

const getSharedPresentationsAction = async ({ commit, state }, payload = {}) => {
  const res = await PresentationApi.getSharedPresentations(payload)
  // Fix AHA-5419
  const { presentations, numberOfPresentationPages } = res
  if (payload.page === 1) {
    commit('setPresentations', presentations)
  } else {
    commit('setPresentations', [...state.presentations, ...presentations])
  }

  commit('setNumberOfPresentationPages', numberOfPresentationPages)
}

export default {
  setPresentationsAction,
  getPresentationsAction,
  getSharedPresentationsAction,
}
